import React from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';

const AdBuilderWarning = (props) => {
  const {
    formKeys,
    isWarningModalOpen,
    toggleWarningModal,
    saveAdPrototype
  } = props;

  const mappedKeys = formKeys.map((key) => {
    switch (key) {
      case 'name':
        return 'Name';
      case 'message':
        return 'Text';
      case 'title':
        return 'Headline';
      case 'tile':
        return 'Tile Asset';
      case 'canvas':
        return 'Canvas';
      case 'callToAction':
        return 'Call To Action';
      case 'cards':
        return "Carousel Cards (require at least 2 cards. Don't forget the asset, headline, and description for each)";
      case 'footerCopy':
        return 'Label';
      case 'description':
        return 'News Link Description';
      case 'asset':
        return 'Image/Video Asset';
      default:
        return key;
    }
  });

  return (
    <Modal
      open={isWarningModalOpen}
      onClose={toggleWarningModal}
      dimmer="inverted"
    >
      <Modal.Header>Confirm Form Submission</Modal.Header>
      <Modal.Content>
        <p>The following fields have not been filled: </p>
        <ul>
          {mappedKeys.map((key) => (
            <li>{key}</li>
          ))}
        </ul>

        <p>
          <Icon name="warning" />
          It may not be possible to launch the ad without these fields. Are you
          sure you want to Submit this form?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button content="No" onClick={toggleWarningModal} />
        <Button primary content="Yes" onClick={saveAdPrototype} />
      </Modal.Actions>
    </Modal>
  );
};

export default AdBuilderWarning;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderWarningModal.jsx